// ───────────────────────────────────────────────────────────────────────
// VIDEO PLACEHOLDER — HOW TO REPLACE:
// 1. YouTube / Vimeo / Wistia / custom iframe: keep this outer frame
//    (silver border + blue glow) and replace the inner placeholder markup
//    with your embed, e.g.:
//      <iframe
//        src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
//        title="7FCC video"
//        className="absolute inset-0 h-full w-full"
//        allow="autoplay; fullscreen; picture-in-picture"
//        allowFullScreen
//        loading="lazy"
//      />
// 2. Keep the video unloaded until play (lazy) — do not auto-load heavy
//    video content on the funnel.
// ───────────────────────────────────────────────────────────────────────
export default function VideoPlaceholder({ label, className = "", testId }) {
  return (
    <div
      className={`group relative aspect-video w-full overflow-hidden rounded-lg border border-line shadow-panel transition-colors duration-500 hover:border-silver-mid ${className}`}
      data-testid={testId}
    >
      <div className="media-slot absolute inset-0" aria-hidden="true" />
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-5 px-6 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full border border-silver/30 bg-ink-800/70 text-silver backdrop-blur transition-colors duration-300 group-hover:border-brand group-hover:text-brand-light">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M8 5.5v13l11-6.5-11-6.5z" />
          </svg>
        </span>
        <span className="text-[11px] font-semibold uppercase tracking-[0.24em] text-fg-dim">
          {label}
        </span>
      </div>
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-silver/40 to-transparent"
        aria-hidden="true"
      />
    </div>
  );
}
